<div class="landing-shell" [class.landing-shell--active]="(showIntro$ | async) === true">
	<section class="intro" *ngIf="showIntro$ | async">
		<h1>Parallel Scalability Viewer</h1>
		<p>
			Upload a JSON report generated by PaScal Analyzer to visualize parallel efficiency,
			scalability behavior, and region-level performance with interactive heatmap charts.
		</p>
		<p class="steps-title">How to start:</p>
		<ol>
			<li>Select your analyzer output file in JSON format.</li>
			<li>Wait for the charts to load.</li>
			<li>Explore regions and compare results to spot bottlenecks quickly.</li>
		</ol>
	</section>

	<app-upload-json></app-upload-json>
</div>
<!-- <app-heatmap></app-heatmap>
 -->
